export default "__VITE_ASSET__6f9c1e37__"